import { ActiveModelSerializer } from 'active-model-adapter';
import DS, { ModelSchema } from 'ember-data';
import { ModelRegistry } from 'ember-data/model';

export default class InAppMessageTemplateSerializer extends ActiveModelSerializer {
  normalizeResponse(
    store: DS.Store,
    type: ModelSchema<keyof ModelRegistry>,
    payload: Record<string, any>,
    id: string,
    requestType: string,
  ) {
    // serializer expects by default find model list as { modelNameOnPlural: model[] }
    // since our backends return messages with a more generic name we adapt returned payload to fit expected format.
    payload.in_app_message_templates = payload.messages;
    delete payload.messages;
    return super.normalizeResponse(store, type, payload, id, requestType);
  }
}
